import { render, staticRenderFns } from "./AirportSubmit.vue?vue&type=template&id=10ae5ed8&scoped=true&"
import script from "./AirportSubmit.vue?vue&type=script&lang=js&"
export * from "./AirportSubmit.vue?vue&type=script&lang=js&"
import style0 from "./AirportSubmit.vue?vue&type=style&index=0&id=10ae5ed8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ae5ed8",
  null
  
)

export default component.exports